import React, { useState, useEffect } from 'react';
import "./Navbar.scss";
import { images } from '../../constants';
import { HiMenuAlt4, HiX } from 'react-icons/hi';
import { BsSun, BsMoon } from 'react-icons/bs';
import { motion } from 'framer-motion';
import { useTheme } from '../../context/ThemeContext';

const Navbar = () => {
    const [Toggle, setToggle] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const { isDarkMode, toggleTheme } = useTheme();

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <nav className={`app__navbar ${isScrolled ? 'scrolled' : ''}`}>
            <div className='app__navbar-logo'>
                <img src={images.arpitweb3} alt="logo" />
            </div>

            <ul className='app__navbar-links'>
                {['home', 'about', 'work', 'skills', 'testimonial', 'contact'].map((item) => (
                    <li className='app__flex p-text' key={`link-${item}`}>
                        <div />
                        <a href={`#${item}`}>{item}</a>
                    </li>
                ))}
            </ul>

            <div className='app__navbar-theme-toggle'>
                <button onClick={toggleTheme} className='theme-toggle-btn'>
                    {isDarkMode ? <BsSun size={24} /> : <BsMoon size={24} />}
                </button>
            </div>

            <div className='app__navbar-menu'>
                <HiMenuAlt4 onClick={() => setToggle(true)} />
                {Toggle && (
                    <motion.div
                        whileInView={{ x: [300, 0] }}
                        transition={{ duration: 0.85, ease: 'easeOut' }}
                    >
                        <HiX onClick={() => setToggle(false)} />
                        <ul>
                            {['home', 'about', 'work', 'skills', 'testimonial', 'contact'].map((item) => (
                                <li key={item}>
                                    <a href={`#${item}`} onClick={() => setToggle(false)}>{item}</a>
                                </li>
                            ))}
                            <li className="theme-toggle-mobile">
                                <button onClick={toggleTheme} className='theme-toggle-btn'>
                                    {isDarkMode ? 'Light Mode' : 'Dark Mode'}
                                </button>
                            </li>
                        </ul>
                    </motion.div>
                )}
            </div>
        </nav>
    );
};

export default Navbar;